import { render, staticRenderFns } from "./FigureSign.vue?vue&type=template&id=284f6955&"
import script from "./FigureSign.vue?vue&type=script&lang=js&"
export * from "./FigureSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports